











































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { Event, emptyEvent, VForm, User, ShallowEvent, emptyShallowEvent } from '@/types'
import { keysToCamel, splitTimestamp } from '@/utils/mappers'
import { env } from '@/utils/env'

interface EventForm {
  name: string;
  assignees: number[];
  startsAtDate: string;
  startsAtTime: string;
}

const emptyEventForm = (): EventForm => ({
  name: '',
  assignees: [],
  startsAtDate: new Date().toISOString().substr(0, 10),
  startsAtTime: '12:00'
})

@Component
export default class Home extends Vue {
  private events: Event[] = []
  private users: User[] = []

  private fab: boolean = false
  private loadingEvents: boolean = false
  private loadingUsers: boolean = false
  private creatingEvent: boolean = false
  private loadingEvent: boolean = false
  private editingEvent: boolean = false

  private addEventDialog: boolean = false
  private addEventForm: EventForm = emptyEventForm()

  private editEventDialog: boolean = false
  private editEventForm: EventForm = emptyEventForm()
  private editEvent: ShallowEvent = emptyShallowEvent()

  private rules = {
    required: (value: any) => !!value || 'This field is required'
  }

  created () {
    this.readEvents()
  }

  async readEvents () {
    this.loadingEvents = true

    try {
      let res = await this.$axios.get<Event[]>(env.apiUrl + '/events')

      this.events = keysToCamel(res.data)
    } catch (err) {
      // TODO snack bus
      console.log('Read Events Error:', err)
    }

    this.loadingEvents = false
    this.fab = true
  }

  async readEvent (eventId: number) {
    this.loadingEvent = true

    try {
      let res = await this.$axios.get<ShallowEvent>(env.apiUrl + `/events/${eventId}`)

      this.editEvent = keysToCamel(res.data)
    } catch (err) {
      // TODO snack bus
      console.log('Edit Event Error:', err)
    }

    this.loadingEvent = false
  }

  async readUsers () {
    this.loadingUsers = true

    try {
      let res = await this.$axios.get<User[]>(env.apiUrl + '/users')

      this.users = keysToCamel(res.data)
    } catch (err) {
      console.log('Read Users Error:', err)
    }

    this.loadingUsers = false
  }

  openAddEventDialog () {
    this.readUsers()

    this.addEventForm = emptyEventForm()
    // TODO figure out why this doesn't work
    // this.$refs.addEventForm.resetValidation()
    this.addEventDialog = true
  }

  async openEditEventDialog (eventId: number) {
    await this.readEvent(eventId)

    this.readUsers()

    let timestamp = splitTimestamp(this.editEvent.startsAt)

    this.editEventForm = {
      name: this.editEvent.name,
      assignees: this.editEvent.assigneeIds,
      startsAtDate: timestamp.date,
      startsAtTime: timestamp.time
    }

    this.editEventDialog = true
  }

  async onCreate () {
    if (!(this.$refs.addEventForm as VForm).validate()) {
      // TODO snack bus
      return
    }

    this.creatingEvent = true

    let formData = {
      name: this.addEventForm.name,
      starts_at: this.addEventForm.startsAtDate + ' ' + this.addEventForm.startsAtTime + ':00',
      assignees: this.addEventForm.assignees
    }

    try {
      let res = await this.$axios.post<Event>(env.apiUrl + '/events', formData)

      this.addEventDialog = false
      this.readEvents()
    } catch (err) {
      // TODO snack bus
      console.log('Create Event Error:', err)
    }

    this.creatingEvent = false
  }

  async onUpdate () {
    if (!(this.$refs.editEventForm as VForm).validate()) {
      // TODO snack bus
      return
    }

    this.editingEvent = true

    const eventId = this.editEvent.id

    const formData = {
      name: this.editEventForm.name,
      starts_at: this.editEventForm.startsAtDate + ' ' + this.editEventForm.startsAtTime + ':00',
      assignees: this.editEventForm.assignees
    }

    try {
      let res = await this.$axios.patch<Event>(env.apiUrl + `/events/${eventId}`, formData)

      this.editEventDialog = false
      this.readEvents()
    } catch (err) {
      // TODO snack bus
      console.log('Edit Event Error:', err)
    }

    this.editingEvent = false
  }
}
